import React from 'react';
import '../Font&Color.css';
import '../thumbnail&details.css';
import '../divs.css';
import './설비현황.css';


export default function 설비현황() {
  return (
    <div>
        <div>
            <h1 className='header1'>설비현황</h1>
            <div className='start'></div>
        </div>

        <div className='main bg2'>
            <div className='oneA'>
                <h1 className='header2'>공정설비현황</h1>
                <hr></hr>
            </div>
            <div className='oneA'>
              <table className='t33'>
              <tr className='t33r'>
                <td className='t33d1'>1호기</td>
                <td className='t33d2'>JSW 1,800 TON</td>
                <td className='t33d3 blue'>전동식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>2호기</td>
                <td className='t33d2'>JSW 650 TON</td>
                <td className='t33d3 blue'>전동식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>3호기</td>
                <td className='t33d2'>미쯔비시 2,000 TON</td>
                <td className='t33d3'>유압식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>4호기</td>
                <td className='t33d2'>우진프라임 650 TON</td>
                <td className='t33d3'>유압식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>5호기</td>
                <td className='t33d2'>미쯔비시 1,050 TON</td>
                <td className='t33d3'>하이브리드</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>6호기</td>
                <td className='t33d2'>JSW 850 TON</td>
                <td className='t33d3 blue'>전동식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>7호기</td>
                <td className='t33d2'>우진 1,300 TON</td>
                <td className='t33d3'>하이브리드</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>8호기</td>
                <td className='t33d2'>도시바 1,300 TON</td>
                <td className='t33d3'>유압식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>9호기</td>
                <td className='t33d2'>도시바 1,300 TON</td>
                <td className='t33d3'>유압식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>10호기</td>
                <td className='t33d2'>도시바 1,600 TON</td>
                <td className='t33d3'>유압식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>11호기</td>
                <td className='t33d2'>구매진행예정</td>
                <td className='t33d3 blue'>전동식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>12호기</td>
                <td className='t33d2'>도시바 450 TON</td>
                <td className='t33d3 blue'>전동식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>13호기</td>
                <td className='t33d2'>JSW 450 TON</td>
                <td className='t33d3 blue'>전동식</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d1'>14호기</td>
                <td className='t33d2'>도시바 650 TON</td>
                <td className='t33d3'>유압식</td>
              </tr>
              </table>

              <table className='t33'>
              <tr className='t33r'>
                <td className='t33d1'>NO</td>
                <td className='t33d1'>설비명</td>
                <td className='t33d1'>용량</td>
                <td className='t33d1'>대수</td>
                <td className='t33d1'>비고</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>1</td>
                <td className='t33d2'>IMG 진공 성형기</td>
                <td className='t33d2'>30 TON</td>
                <td className='t33d2'>1</td>
                <td className='t33d2'>IMG 매스비끼</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>2</td>
                <td className='t33d2'>IMG 진공 성형기</td>
                <td className='t33d2'>15 TON</td>
                <td className='t33d2'>1</td>
                <td className='t33d2'>IMG 매스비끼</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>3</td>
                <td className='t33d2'>IMG 진공 성형기</td>
                <td className='t33d2'>15 TON</td>
                <td className='t33d2'>1</td>
                <td className='t33d2'>IMG 매스비끼</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>4</td>
                <td className='t33d2'>IMG 진공 성형기</td>
                <td className='t33d2'>15 TON</td>
                <td className='t33d2'>1</td>
                <td className='t33d2'>IMG 매스비끼</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>5</td>
                <td className='t33d2'>진공 성형기</td>
                <td className='t33d2'>50 kw</td>
                <td className='t33d2'>1</td>
                <td className='t33d2'>IMG 매스비끼</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>6</td>
                <td className='t33d2'>진공 성형기</td>
                <td className='t33d2'>150 TON</td>
                <td className='t33d2'>1</td>
                <td className='t33d2'>오스비끼</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>6</td>
                <td className='t33d2'>진공 성형기</td>
                <td className='t33d2'>150 TON</td>
                <td className='t33d2'>1</td>
                <td className='t33d2'>오스비끼</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>7</td>
                <td className='t33d2'>TRIM&PIERC'G</td>
                <td className='t33d2'>150 TON</td>
                <td className='t33d2'>2</td>
                <td className='t33d2'>PRESS</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>8</td>
                <td className='t33d2'>TRIM&PIERC'G</td>
                <td className='t33d2'>30 TON</td>
                <td className='t33d2'>3</td>
                <td className='t33d2'>PRESS</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>9</td>
                <td className='t33d2'>TRIM&PIERC'G</td>
                <td className='t33d2'>20 TON</td>
                <td className='t33d2'>4</td>
                <td className='t33d2'>PRESS</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>10</td>
                <td className='t33d2'>AIR BLOW 압착기</td>
                <td className='t33d2'>50 TON</td>
                <td className='t33d2'>1</td>
                <td className='t33d2'>PRESS</td>
              </tr>
              <tr className='t33r'>
                <td className='t33d2'>11</td>
                <td className='t33d2'>자동 스티치 미싱기</td>
                <td className='t33d2'>-</td>
                <td className='t33d2'>3</td>
                <td className='t33d2'>미싱기</td>
              </tr>
              
              </table>
              <br></br>
            </div>
            
            
            <div className='oneA'>
              <div className='tbox'>
                <h4 className='bold'>진공성형기 <span className='logocolor3'>6대</span></h4>
                <h4 className='bold'>TRIM&PIERC'G PRESS <span className='logocolor3'>9대</span></h4>
                <h4 className='bold'>AIR BLOW 압착기 <span className='logocolor3'>1대</span></h4>
                <h4 className='bold'>자동 스티치 미싱기 <span className='logocolor3'>3대</span></h4> 
              </div>
            </div>

        </div>
    </div>
  );
}
